module.exports = __webpack_public_path__ + "static/media/linkedin.74c49d0c.png";